<template>
  <div :class="$style.wrapper">
    <ds-drop-down>
      <div
        slot="header"
        :class="$style.header"
      >
        <div :class="$style['item-icon']">
          <component
            v-if="headerIcon"
            :is="headerIcon"
          />
        </div>
        <span :class="$style['item-title']">
          {{ headerTitle }}
        </span>
      </div>
      <ul
        slot="content"
        :class="$style.items"
      >
        <VuePerfectScrollbar
          ref="perfectScollbar"
          :class="$style['scroll-area']"
          :settings="settings"
        >
          <li
            v-for="option in options"
            :key="option.key"
            :class="$style.item"
          >
            <ds-checkbox
              :checked="option.selected"
              :show-error-box="false"
              :id="option.key"
              :class="$style['checkbox-wrapper']"
              :name="`option_${option.key}`"
              @onChecked="onChecked(option)"
            >
              <span slot="content">
                {{ option.name }}
              </span>
            </ds-checkbox>
          </li>
        </VuePerfectScrollbar>
      </ul>
    </ds-drop-down>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DsCheckbox from "./ds-checkbox";
import DsDropDown from "./ds-dropdown";
import Label from "./ds-label";

export default {
  name: "DsMultiselect",
  components: {
    DsDropDown,
    DsCheckbox,
    Label,
    VuePerfectScrollbar
  },
  props: {
    headerIcon: {
      type: Object,
      default: null
    },
    headerTitle: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 50
      }
    };
  },
  mounted() {
    this.$refs.perfectScollbar.update();
  },
  methods: {
    onChecked(option) {
      this.$emit("onChange", option);
    }
  }
};
</script>

<style lang="scss" module>
@import "../../scss/_variables.scss";

.scroll-area {
  margin: auto;
  width: 275px;
  max-height: 30vh;
  margin-left: 0px;
}
.wrapper {
  background-color: #fff;
  border-radius: 5px;
  z-index: 1;
  label {
    padding: 5px 0px;
    span {
      margin-top: 5px;
    }
  }
}
.header {
  display: flex;
  align-items: center;
  min-width: 250px;
}
.items {
  padding-top: 0px;
  padding: 5px 0px;
}
.item {
  padding: 0px 10px;
  width: 100%;
  &:hover {
    background-color: $light-silver-color;
  }
}
.item-icon {
  display: flex;
  align-items: center;
  vertical-align: middle;
  height: 20px;
  margin-right: 10px;
  img {
    height: 20px;
  }
}
.item-title {
  vertical-align: middle;
  font-weight: 600;
}
.checkbox-wrapper {
  > span {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-multiselect.vue